import { ApiPaths } from "@app/helpers/api";
import { responseStatus } from "../constants";
import { ChiTietKPICaNhan, DownloadFileKPIRequest, ImportFileKPI, ImportFileKPIRequest, KPICaNhan, LoiViPhamCaNhan } from "../models/kpi/KPICaNhan";
import intance from "../utils/axios";
import { KPIPhongBanResponse, KPIThang, TheoDoiCongViec, ThongKeKPIResponse } from '../models/kpi/KPIPhongBan';
import { LuuDSTieuDeKPIRequest, TieuDeKPI, TieuDeKPINhanVien } from '../models/kpi/TieuDeKPI';
import { getFormData } from "../helpers/common";


export const layDSKPICaNhan = async (thoiGian: any) => {
    var rs: any;
    await intance.get(`${ApiPaths.kpi.layDsKPICaNhan}?thoiGian=${thoiGian}`).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
    return rs;
}
export const luuTaiLieuKPICaNhan = async (request: any) => {
    var rs: any;
    const formData = new FormData();
    formData.append("id", request.id ?? "");
    request.nhomKPI.forEach((nhom: any, i: number) => {

        formData.append(`nhomKPI[${i}].id`, nhom.id ?? "");
        nhom.idsTaiLieuXoa?.forEach((id: number, j: number) => {
            formData.append(
                `nhomKPI[${i}].idsTaiLieuXoa[${j}]`,
                id.toString()
            );
        });

        nhom.dsTaiLieu?.forEach((file: any) => {
            formData.append(
                `nhomKPI[${i}].files`,
                file
            );
        });
    });

    await intance.post(ApiPaths.kpi.luuTaiLieuKPI, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const luuKPICaNhan = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.luuKPICaNhan, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const luuChiTietKPICaNhan = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.luuChiTietKPICaNhan, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}
export const luuGiaoViecKPI = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.luuGiaoViecKPI, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const saoChepChiTietKPI = async (ids: Array<number>) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.SaoChepChiTietKPI, { idChiTiets: ids })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}
export const saoChepChiTietKPILoi = async (ids: Array<number>) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.SaoChepChiTietKPILoi, { idChiTiets: ids })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const luuLoiViPhamKPI = async (data: any) => {
    await intance.post(ApiPaths.kpi.luuLoiViPhamKPI, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaLoiViPhamKPI = async (id: number) => {
    await intance.post(ApiPaths.kpi.xoaLoiViPhamKPI + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const lienKetChiTietKPICaNhan = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.lienKetKPIDenNhanVienKhac, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const layNhomKPICaNhan = async () => {
    var data;
    await intance.get(ApiPaths.kpi.layNhomKPICaNhan).then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        } else {
            throw Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return data;
}

export const layCongViecChuaHoanThanh = async (thangNam: string) => {
    var data;
    await intance.get(ApiPaths.kpi.layDSChiTietKPIChuaHoanThanh + "?thangNam=" + thangNam).then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        } else {
            throw Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw err;
    });
    return data;
}

export const layKPICaNhan = async (request: any) => {
    var rs: any;
    await intance.get(ApiPaths.kpi.layKPICaNhan + "?id=" + request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const layThongTinNhanVien = async () => {
    var rs: any;
    await intance.get(ApiPaths.kpi.layThongTinNhanVien)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const xoaKPICaNhan = async (request: any) => {
    await intance.post(ApiPaths.kpi.xoaKPICaNhan + "?id=" + request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
}

export const trinhKPILanhDaoPhong = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.trinhLanhDaoPhong, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
}

export const trinhKPILanhDaoPhuTrach = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.trinhLanhDaoPhuTrach, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const trinhKPILanhDaoDonVi = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.trinhLanhDaoDonVi, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err;
        });
    return rs;
}

export const duaYKienKPICaNhan = async (request: any) => {
    var rs = 0;
    await intance.post(ApiPaths.kpi.duaYKienKPICaNhan, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const pheDuyetKPICaNhan = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.pheDuyetKPICaNhan, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const LDPTPheDuyetKPICaNhan = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.LDPTPheDuyetKPICaNhan, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const thuHoiKPICaNhan = async (idKPI: number) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.thuHoiKPICaNhan + "?idKPI=" + idKPI)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const timKiemDSKPIPhongBan = async (idDonVi: number, tuKhoa: string, thangNam: string) => {
    var data = {
        data: [],
        nhanViens: [],
    };
    await intance.post(ApiPaths.kpi.layDsKPIPhongBan, {
                "idDonVi": idDonVi,
                "tuKhoa": tuKhoa,
                "thoiGian": thangNam
        })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const timKiemDSKPIDuyet = async (idDonVi: number, tuKhoa: string, thangNam: string) => {
    var data: any = {
        data: [],
        nhanViens: [],
    };
    await intance.post(ApiPaths.kpi.layDsKPIDuyet, {
        "idDonVi": idDonVi,
        "tuKhoa": tuKhoa,
        "thoiGian": thangNam
    }).then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};
export const timKiemDSKPIYKien = async (idDonVi: number, tuKhoa: string, thangNam: string) => {
    var data: any = {
        data: [],
        nhanViens: [],
    };
    await intance.post(ApiPaths.kpi.layDsKPIYKien, {
        "idDonVi": idDonVi,
        "tuKhoa": tuKhoa,
        "thoiGian": thangNam
    }).then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        } else {
            throw Error(res.data.thongBao);
        }
    })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const importFileKPI = async (request: ImportFileKPIRequest) => {
    var rs: Array<KPICaNhan> = new Array<KPICaNhan>();
    await intance.post(ApiPaths.kpi.importFileKPI,
        request,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const downloadFileTemplateKPI = async (request: DownloadFileKPIRequest) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.downloadFileTemplateKPI, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const themTongHopKPIThang = async (data: any, files: any[], idsTaiLieuXoa: number[]) => {
    var rs: KPIThang = new KPIThang;
    var formData = getFormData(data);
    files.forEach((file, index) => {
        formData.append("files", file);
    })
    idsTaiLieuXoa.forEach((item, index) => {
        formData.append("idsTaiLieuXoa", item.toString());
    })
    await intance.post(ApiPaths.kpi.themTongHopKPIThang, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });

    return rs;
}
export const thuHoiTongHopKPI = async (idKPI: number) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.thuHoiTongHopKPI + "?idKPITongHop=" + idKPI)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const pheDuyetTongHopKPI = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.pheDuyetTongHopKPI, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
            rs = res.data.duLieu;
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
    return rs;
}
export const layTongHopKPIThang = async (thangNam: string) => {
    var rs: KPIThang | null = new KPIThang();
    await intance.get(ApiPaths.kpi.layTongHopKPIThang + "?thangNam=" + thangNam)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const lanhDaoPhongPheDuyetKPI = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.lanhDaoPhongPheDuyet, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const lanhDaoPhongTrinhKPI = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.kpi.lanhDaoPhongTrinh, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}

export const layDSLoiViPhamKPI = async (thoiGian: string) => {
    var data: Array<any> = [];
    await intance.get(ApiPaths.kpi.layDSLoiViPhamKPI + "?thoiGian=" + thoiGian)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layDSLoiViPhamKPICaNhan = async (idKPI: number) => {
    var data: Array<LoiViPhamCaNhan> = [];
    await intance.get(ApiPaths.kpi.layDSLoiViPhamKPICaNhan + "?id=" + idKPI)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const thongKeKPICaNhan = async (idKPI: number) => {
    var data: ThongKeKPIResponse = { data: [], theoDoiGiaoViecs: [] };
    await intance.get(ApiPaths.kpi.thongKeKPICaNhan + "?id=" + idKPI)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                const duLieu = res.data.duLieu;
                // API có thể trả về mảng (bản cũ) hoặc object { data, theoDoiGiaoViecs }
                data = Array.isArray(duLieu)
                    ? { data: duLieu, theoDoiGiaoViecs: [] }
                    : {
                        data: Array.isArray(duLieu?.data) ? duLieu.data : [],
                        theoDoiGiaoViecs: Array.isArray(duLieu?.theoDoiGiaoViecs) ? duLieu.theoDoiGiaoViecs : [],
                    };
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};
export const thongKeKPIPhongBan = async (idDonVi: number, thangNam: string) => {
    var data: Array<KPIPhongBanResponse> = [];

    await intance.post(ApiPaths.kpi.thongKeKPIPhongBan, {
        "idDonVi": idDonVi,
        "thoiGian": thangNam
    }).then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        } else {
            throw Error(res.data.thongBao);
        }
    })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const timKiemGiaoViecKPI = async (request: any) => {
    var data: Array<TheoDoiCongViec> = [];

    await intance.post(ApiPaths.kpi.timKiemGiaoViecKPI, request).then((res) => {
        if (res.data.trangThai == responseStatus.thanhCong) {
            data = res.data.duLieu;
        } else {
            throw Error(res.data.thongBao);
        }
    })
        .catch((err) => {
            throw err;
        });
    return data;
};

// ẩn công việc được giao khỏi bảng thống kê theo dõi giao việc (AnIdNVGiao = true)
export const anGiaoViecKPI = async (idChiTiets: Array<number>, an: boolean = true) => {
    await intance.post(ApiPaths.kpi.anGiaoViecKPI, { idChiTiets: idChiTiets, an: an })
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

// lãnh đạo đã giao việc sửa lại thông tin công việc trong bảng theo dõi giao việc
export const suaGiaoViecKPI = async (request: any) => {
    await intance.post(ApiPaths.kpi.suaGiaoViecKPI, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

// lãnh đạo đã giao việc xóa cả chuỗi bản ghi của công việc khỏi KPI nhân viên
export const xoaGiaoViecKPI = async (idChiTiets: Array<number>) => {
    await intance.post(ApiPaths.kpi.xoaGiaoViecKPI, { idChiTiets: idChiTiets })
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xuatExcelGiaoViecKPI = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.baoCao.xuatExcelGiaoViecKPI, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}
export const vanPhongTraLaiKPICaNhan = async (request: any) => {
    await intance.post(ApiPaths.kpi.vanPhongTraLaiKPICaNhan, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const layMauImportKPI = async () => {
    var rs: any;
    await intance.get(ApiPaths.kpi.layMauImportKPI, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const layDSTieuDeKPI = async () => {
    var rs: Array<TieuDeKPINhanVien> = [];
    await intance.get(`${ApiPaths.kpi.layDSTieuDeKPI}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};


export const layDSTieuDeKPITheoNhanVien = async () => {
    var rs: Array<TieuDeKPI> = [];
    await intance.get(`${ApiPaths.kpi.layDSTieuDeKPITheoNhanVien}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};
export const luuDSTieuDeKPI = async (request: LuuDSTieuDeKPIRequest) => {
    var rs: Array<TieuDeKPI> = [];
    await intance.post(ApiPaths.kpi.luuDSTieuDeKPI, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err.message;
        });
    return rs;
};

export const importFileKPICaNhan = async (request: ImportFileKPI) => {
    var rs: Array<ChiTietKPICaNhan> = new Array<ChiTietKPICaNhan>();
    await intance.post(ApiPaths.kpi.importFileKPI,
        request,
        {
            headers: {
                "Content-Type": "multipart/form-data",
                "Accept": "application/json",
            },
        }
    )
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};
